import * as IMG from '@Utils/Images';

const PartnersImage = (props) => {
  return <img src={props.value} alt="partners" width="80%" />;
};

export default function Component() {
  return (
    <section className="partners-section text-center">
      <div className="subtitle">Partnership</div>
      <h1 className="title fw-bold mb-5">Our Partners</h1>
      <div className="bg-main partners">
        <div className="container">
          <div className="row justify-content-sm-between justify-content-center align-items-center m-0 py-5">
            <div className="col-md-2 col-sm-5 col-7 p-0">
              <PartnersImage
                value={IMG.PARTNERS_1}
              />
            </div>
            <div className="col-md-2 col-sm-5 col-7 mt-5 mt-sm-0 p-0">
              <PartnersImage
                value={IMG.PARTNERS_2}
              />
            </div>
            <div className="col-md-2 col-sm-5 col-7 mt-5 mt-md-3 p-0 mt-3">
              <PartnersImage
                value={IMG.PARTNERS_3}
              />
            </div>
            <div className="col-md-2 col-sm-5 col-7 mt-5 mt-md-0 p-0">
              <PartnersImage
                value={IMG.PARTNERS_4}
              />
            </div>
            <div className="col-md-2 col-sm-5 col-7 mt-5 mt-md-0 p-0">
              <PartnersImage
                value={IMG.PARTNERS_5}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};